import { ReactComponent as Arrow } from 'assets/icons/chevronBlue.svg'
import classNames from 'classnames'
import React, { MouseEventHandler } from 'react'
import { Button } from 'ui'

import styles from './MenuBlock.module.scss'

export type TMenuBlock = {
  Icon?: React.FunctionComponent
  link?: string
  text: string
  className?: string
  blank?: boolean
  handleClick?: MouseEventHandler<HTMLButtonElement>
  'data-testid'?: string
}

export function MenuBlock({
  Icon,
  link = '',
  text,
  className = '',
  blank = false,
  handleClick = () => {},
  'data-testid': dataTestId,
}: TMenuBlock) {
  return (
    <Button
      //@ts-ignore
      to={link}
      className={classNames(styles.menuBlock, className)}
      underline='none'
      target={blank ? '_blank' : ''}
      onClick={handleClick}
      data-testid={dataTestId}
    >
      <div className={styles.menuBlockLeft}>
        {Icon && <Icon />}
        <p className={Icon && styles.menuBlockTitle}>{text}</p>
      </div>
      <Arrow />
    </Button>
  )
}
